<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('FORMS.LIST_HEADER') }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        dark
        color="indigo"
        @click="
          $router.push({
            name: 'forms.create'
          })
        "
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }}
      </v-btn>
    </v-toolbar>

    <item-list @show="show" />
  </div>
</template>

<script>
export default {
  name: 'Forms',

  components: {
    ItemList: () => import('@/modules/forms/components/FormList.vue')
  },

  data: () => ({}),

  computed: {},

  created() {},

  methods: {
    show(item) {
      this.$router.push({
        name: 'forms.show',
        params: { id: item.id }
      });
    }
  }
};
</script>
